import React from 'react';
import classNames from 'classnames';
import PageActions from './PageActions';

import styles from '../CapabilitiesAssessmentEditor.module.scss';

/**
 * A page of a type this editor doesn't know (removed or renamed, say). It
 * shows what it can, read-only, so the page can be recognized and deleted;
 * until it is, the assessment can't launch.
 */
function UnknownPage({ page }) {
  return (
    <div className={classNames(styles.page, styles['page-unknown'])}>
      <div className={styles['page-content']}>
        <div className={styles['page-header']}>
          <div className={styles['page-unknown-type']}>
            Unknown page type: {page.type ?? '(none)'}
          </div>
          <div className={styles['page-guid']}>{page.key ?? page.guid}</div>
        </div>
        {page.title && <div className={styles['page-title']}>{page.title}</div>}
        {page.description && (
          <div className={styles['page-description']}>{page.description}</div>
        )}
        <p className={styles['page-unknown-note']}>
          This page can't be edited or launched. Delete it before going live.
        </p>
        <section className={styles['page-footer']}>
          <div />
          <PageActions page={page} />
        </section>
      </div>
    </div>
  );
}

export default UnknownPage;
